module.exports = __webpack_public_path__ + "static/media/eternalblue.9be3bc26.PNG";